module.exports = __webpack_public_path__ + "static/img/zffx.0a24267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zffx.png
// module id = ixQu
// module chunks = 1